<div class="paginator">
  <div class="paginator-container">
    <button #first class="icon-button" (click)="onClickFirstPage()" [disabled]="pageIndex + 1 === 1">
      <app-svg-icon [icon]="language === 'ar' ? IconsConstants.LAST_ICON : IconsConstants.FIRST_ICON"></app-svg-icon>
    </button>
    <button #previous class="icon-button" (click)="onClickPreviousPage()" [disabled]="pageIndex + 1 === 1">
      <app-svg-icon [icon]="language === 'ar' ? IconsConstants.NEXT_ICON : IconsConstants.PREV_ICON"></app-svg-icon>
    </button>
    <ng-container *ngFor="let pageNumber of renderedPages">
      <div class="icon-button" [ngClass]="{'current' : pageNumber == pageIndex + 1, 'expand-button': pageNumber | digitsNumber : 3}" (click)="onClickPage(pageNumber)">
        <button><span>{{pageNumber | numberFormat:false:true}}</span></button>
      </div>
    </ng-container>
    <button #next class="icon-button" (click)="onClickNextPage()" [disabled]="pageIndex + 1 >= totalPages">
      <app-svg-icon [icon]="language === 'ar' ? IconsConstants.PREV_ICON : IconsConstants.NEXT_ICON"></app-svg-icon>
    </button>
    <button #last class="icon-button" (click)="onClickLastPage()" [disabled]="pageIndex + 1 >= totalPages">
      <app-svg-icon [icon]="language === 'ar' ? IconsConstants.FIRST_ICON : IconsConstants.LAST_ICON"></app-svg-icon>
    </button>
  </div>
  <div class="paginator-data">
    <span>{{'PAGINATOR.ITEMS_PER_PAGE' | translate}}</span>
    <mat-select [(ngModel)]="pageSize" (selectionChange)="onSelectPageSize($event)">
      <mat-option [value]="10">{{'10' | numberFormat:true:true}}</mat-option>
      <mat-option [value]="50">{{'50' | numberFormat:true:true}}</mat-option>
      <mat-option [value]="100">{{'100' | numberFormat:true:true}}</mat-option>
    </mat-select>
    <span class="total-pages">{{'PAGINATOR.FROM' | translate}}&nbsp;{{length ? (length | numberFormat:true:true) : 0}}</span>
  </div>
</div>